import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the absence state domain
 */

const selectAbsenceDomain = state => state.absence || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Absence
 */

const makeSelectItemsList = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.itemsList,
  );

const makeSelectItemsListFirstElem = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.firstElem,
    );

const selectAbsenceData = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.absenceData,
  );

const selectUpdatedAbsencesLoading = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.loadingUpdatedList,
  );

const selectAbsencesLoading = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.loading,
  );

const selectAbsenceLoading = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.loadingData,
  );

const selectAbsenceError = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.error,
  );

const selectAbsenceDeleteSuccessful = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.deleteSuccessful,
  );

export {
  selectAbsenceDomain,
  selectAbsenceData,
  selectAbsencesLoading,
  selectAbsenceLoading,
  selectUpdatedAbsencesLoading,
  selectAbsenceError,
  selectAbsenceDeleteSuccessful,
  makeSelectItemsList,
  makeSelectItemsListFirstElem,
};
